import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal-950 text-offwhite-200 py-12 border-t border-charcoal-900" data-id="element-162">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-163">
        <div className="text-center md:text-left" data-id="element-164">
          <a href="#" className="text-2xl font-bold text-offwhite-50 tracking-tight block mb-2" data-id="element-165">
            McLean <span className="text-amber-500" data-id="element-166">PT</span>
          </a>
          <p className="text-sm text-charcoal-500" data-id="element-167">
            Physical Therapy & Performance Coaching · Camarillo, CA
          </p>
        </div>

        <div className="flex items-center space-x-6" data-id="element-168">
          <a href="https://www.instagram.com/mclean_physicaltherapy" target="_blank" rel="noopener noreferrer" className="text-charcoal-500 hover:text-amber-500 transition-colors" data-id="element-169">
            <InstagramIcon size={24} data-id="element-170" />
            <span className="sr-only" data-id="element-171">Instagram</span>
          </a>
          <a href="mailto:info@mcleanphysicaltherapy.com" className="text-charcoal-500 hover:text-amber-500 transition-colors" data-id="element-172">
            <MailIcon size={24} data-id="element-173" />
            <span className="sr-only" data-id="element-174">Email</span>
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-8 pt-8 border-t border-charcoal-900 text-center md:text-left flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-charcoal-600" data-id="element-175">
        <p data-id="element-176">
          &copy; {new Date().getFullYear()} McLean Physical Therapy. All rights
          reserved.
        </p>
        <div className="flex space-x-4" data-id="element-177">
          <a href="#" className="hover:text-offwhite-200 transition-colors" data-id="element-178">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-offwhite-200 transition-colors" data-id="element-179">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}